import CONTENT_TYPES from 'config/constants/CONTENT_TYPES';

const relatedContentOptionsParser = ({ results }) =>
  results.map(({ id, friendly_id, object_content_type, heading, title }) => {
    const label = object_content_type === CONTENT_TYPES.GUIDE || object_content_type === CONTENT_TYPES.INCIDENT_GUIDE ? heading : title;
    return { key: id, label, friendly_id, object_content_type };
  });

export default relatedContentOptionsParser;
